/**
 * @ngdoc method
 * @name util#timeParts
 * @description
 * Convert given duration in seconds into an array with corresponding hours, minutes and
 * seconds values.
 * @param {number} timeInSeconds duration in seconds
 * @returns {string[]} Converted duration into array formed as following :
 * [hours, minutes, seconds]
 */
export function timeParts(timeInSeconds: number): [number, number, number] {
  // tslint:disable
  let hours = (timeInSeconds / 3600) >> 0;
  let hoursRest = timeInSeconds % 3600;
  let min = (hoursRest / 60) >> 0;
  let seconds = hoursRest % 60 >> 0;
  // tslint:enable
  return [hours, min, seconds];
}
